import * as Effect from "effect/Effect";
import { isNonEmptyArray } from "effect/Array";
import { match } from "ts-pattern";
import { Address } from "@silo/types";
import { KvClientError, KvService } from "./types";
import { getSanctionedAddressesKey } from "./keys";

export function getIsSanctioned(
  address: Address
): Effect.Effect<boolean, KvClientError, KvService> {
  return Effect.gen(function* () {
    const kv = yield* KvService;
    const key = getSanctionedAddressesKey();

    const result = yield* Effect.tryPromise({
      try: async () => {
        return kv.sismember(key, address);
      },
      catch: (cause) => new KvClientError({ cause }),
    });

    return match(result)
      .with(0, () => false)
      .with(1, () => true)
      .exhaustive();
  });
}

export function setSanctionedAddresses(
  addresses: Address[]
): Effect.Effect<void, KvClientError, KvService> {
  return Effect.gen(function* () {
    if (!isNonEmptyArray(addresses)) {
      yield* Effect.logWarning("No addresses to update");

      return;
    }

    const kv = yield* KvService;
    const key = getSanctionedAddressesKey();

    yield* Effect.tryPromise({
      try: async () => {
        const pipeline = kv.multi();

        pipeline.del(key);
        pipeline.sadd(key, ...addresses);

        return pipeline.exec();
      },
      catch: (cause) => new KvClientError({ cause }),
    });
  });
}
